import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useHistory } from 'react-router-dom'
import { Instance } from 'mobx-state-tree'

import { useStores, setPageTitle } from '@trivie/core'
import { color } from '@trivie/ui-web/theme'
import { TopicCard } from '@trivie/ui-mobile'
import { UserPath } from '@trivie/core/src/models/workflow/Path'

export interface SubscriptionPathsTabProps {
  contentUserIds: number[]
}

export const SubscriptionPathsTab = observer((props: SubscriptionPathsTabProps) => {
  const { pathStore } = useStores()
  const { userPaths } = pathStore
  const { contentUserIds } = props

  const [windowSize, setWindowSize] = useState({ width: 0, height: 0 })
  const history = useHistory()

  const goToPath = (path: Instance<typeof UserPath>) => {
    setPageTitle(`${path.name} - ${process.env.REACT_APP_SITE_TITLE}`)
    history.push(
      `/library/path/?subscription_user_id=${path.subscription_user_id}&path_id=${path.path_id}`,
    )
  }

  function useWindowSize() {
    useEffect(() => {
      function handleResize() {
        setWindowSize({ width: window.innerWidth, height: window.innerHeight })
      }
      window.addEventListener('resize', handleResize)
      handleResize()
      return () => window.removeEventListener('resize', handleResize)
    }, [])
    return windowSize
  }

  useWindowSize()
  function responsiveGrid() {
    if (windowSize.width < 1024) return THINGRID
    else if (windowSize.width < 1440) return NORMALGRID
    else return WIDEGRID
  }

  const filteredData = userPaths
    .slice()
    .filter((p) => p.content_user_id != null && contentUserIds.includes(p.content_user_id))

  return (
    <div style={CONTENT}>
      <div style={responsiveGrid()}>
        {filteredData.map((path, index) => (
          <TopicCard
            key={`sub-path-${index}`}
            // @ts-ignore
            dataSet={{ qat: `sub-path-card-${index}` }}
            path={path}
            onPress={() => goToPath(path)}
          />
        ))}
      </div>
    </div>
  )
})

const CONTENT: React.CSSProperties = { backgroundColor: color.white, height: '100%' }
const WIDEGRID: React.CSSProperties = {
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gridTemplateRows: '1fr',
  gridGap: 20,
  paddingTop: 0,
  paddingBottom: 20,
}
const NORMALGRID: React.CSSProperties = {
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gridTemplateRows: '1fr',
  gridGap: 20,
  paddingTop: 0,
  paddingBottom: 20,
}
const THINGRID: React.CSSProperties = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gridTemplateRows: '1fr',
  gridGap: 20,
  paddingTop: 0,
  paddingBottom: 20,
}
